import { getTeam } from '@/utils/data';
import type { Match, MatchEvent } from '@/types';

function buildFallback(match: Match): MatchEvent[] {
  return match.quarterScores.map((q) => ({
    time: '',
    quarter: q.quarter,
    team: q.home >= q.away ? 'home' : 'away',
    player: '',
    type: '节间比分',
    score: `${q.home}-${q.away}`,
    desc: `${q.quarter} 结束，本节比分 ${q.home} : ${q.away}。`,
  }));
}

export default function EventTimeline({ match }: { match: Match }) {
  const events = match.events.length > 0 ? match.events : buildFallback(match);
  const home = getTeam(match.homeTeamId);
  const away = getTeam(match.awayTeamId);

  if (events.length === 0) {
    return (
      <div className="px-4 md:px-5 py-10 text-center">
        <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-3">
          <i className="ri-time-line text-xl"></i>
        </span>
        <p className="text-sm text-foreground-500">比赛尚未开始，暂无比赛事件。</p>
      </div>
    );
  }

  return (
    <ol className="relative px-4 md:px-5 py-5">
      <span className="absolute left-[26px] md:left-[30px] top-6 bottom-6 w-px bg-background-200"></span>
      {events.map((ev, i) => {
        const team = ev.team === 'home' ? home : away;
        return (
          <li key={`${ev.quarter}-${i}`} className="relative flex gap-3 md:gap-4 pb-5 last:pb-0 group">
            <span className="relative z-10 w-4 h-4 md:w-5 md:h-5 mt-0.5 rounded-full border-2 border-background-50 shrink-0" style={{ backgroundColor: team?.color }}></span>
            <div className="flex-1 min-w-0 bg-background-100/60 border border-background-200/70 rounded-md px-3 py-2.5 group-hover:border-primary-200 transition-colors">
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="flex items-center gap-2 text-xs">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-800">{ev.quarter}</span>
                  {ev.time && <span className="text-foreground-500">{ev.time}</span>}
                  <span className="font-semibold text-foreground-800">{ev.type}</span>
                </span>
                <span className="font-heading font-bold text-sm text-foreground-900 tabular-nums">{ev.score}</span>
              </div>
              <p className="mt-1 text-xs md:text-sm text-foreground-600">
                <span className="text-foreground-800">{team?.name}</span>
                {ev.player ? ` · ${ev.player}` : ''}
              </p>
              <p className="mt-1 text-xs text-foreground-500 leading-relaxed opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-20 transition-all duration-300 overflow-hidden">
                {ev.desc}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}